export default function inverterSelect({ trackers, formik }) {
  const cars = formik.values.cars || [];
  const filteredCars = trackers
    .filter(({ id }) => !cars.includes(id))
    .map(({ id }) => id);
  formik.setFieldValue('cars', filteredCars);
}
